import { z } from 'zod';
import { LifecycleStateSchema } from './lifecycle.js';
import { EffectiveInstallationHealthSchema } from './installations.js';
/**
 * Mission Overview contract. Every metric carries its definition, source and
 * freshness, and every block names the filtered registry drill-down that
 * backs it — no decorative numbers.
 */
export const MetricDefinitionSchema = z.object({
    /** Human definition of what the number means. */
    definition: z.string(),
    /** Where the number comes from (table / event source). */
    source: z.string(),
    /** When the number was computed. */
    computedAt: z.iso.datetime(),
    /** Relative registry drill-down URL with the exact filters applied. */
    drillDownPath: z.string().nullable(),
});
export const CountMetricSchema = z.object({
    value: z.number().int(),
    meta: MetricDefinitionSchema,
});
export const OverviewResponseSchema = z.object({
    portfolioByLifecycle: z.array(z.object({
        state: LifecycleStateSchema,
        count: z.number().int(),
        meta: MetricDefinitionSchema,
    })),
    deployments: z.object({
        cloud: CountMetricSchema,
        onPrem: CountMetricSchema,
    }),
    installationsByHealth: z.array(z.object({
        health: EffectiveInstallationHealthSchema,
        count: z.number().int(),
        meta: MetricDefinitionSchema,
    })),
    attention: z.object({
        /** Organisations not updated within the staleness window. */
        staleOrganisations: CountMetricSchema,
        /** Active organisations with no contacts recorded. */
        missingContacts: CountMetricSchema,
        /** Active organisations with no internal owner assigned. */
        unowned: CountMetricSchema,
    }),
    recentLifecycleEvents: z.array(z.object({
        id: z.uuid(),
        organisationId: z.uuid(),
        organisationName: z.string(),
        fromState: LifecycleStateSchema.nullable(),
        toState: LifecycleStateSchema,
        actorDisplayName: z.string().nullable(),
        occurredAt: z.iso.datetime(),
    })),
    recentOperatorActivity: z.array(z.object({
        id: z.uuid(),
        actorDisplayName: z.string().nullable(),
        action: z.string(),
        objectType: z.string(),
        objectLabel: z.string().nullable(),
        occurredAt: z.iso.datetime(),
    })),
    generatedAt: z.iso.datetime(),
});
//# sourceMappingURL=overview.js.map